import { useEffect, useMemo, useState } from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { buildApiUrl } from '../lib/api';

export default function PagoResult({ status: statusProp }) {
  const location = useLocation();
  const computedStatus = useMemo(() => {
    const path = location.pathname.toLowerCase();
    if (path.includes('exitoso')) return 'exitoso';
    if (path.includes('fallido')) return 'fallido';
    if (path.includes('pendiente')) return 'pendiente';
    return statusProp || 'fallido';
  }, [location.pathname, statusProp]);
  const [searchParams] = useSearchParams();
  const [confirming, setConfirming] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [error, setError] = useState('');

  const paymentId = searchParams.get('payment_id') || searchParams.get('collection_id') || '';
  const externalReference = searchParams.get('external_reference') || '';

  useEffect(() => {
    if (computedStatus === 'exitoso' && paymentId && externalReference && !confirmed && !confirming) {
      const confirm = async () => {
        setConfirming(true);
        setError('');
        try {
          const response = await fetch(buildApiUrl('/portal/pagos/confirmar'), {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
            },
            body: JSON.stringify({ paymentId, externalReference }),
          });
          const data = await response.json();
          if (!response.ok || !data?.ok) {
            throw new Error(data?.error || 'No se pudo confirmar el pago.');
          }
          setConfirmed(true);
        } catch (err) {
          setError(err.message || 'Error confirmando el pago.');
        } finally {
          setConfirming(false);
        }
      };
      confirm();
    }
  }, [computedStatus, paymentId, externalReference, confirmed, confirming]);

  const config = {
    exitoso: {
      title: 'Pago exitoso',
      message: confirmed
        ? 'El pago fue confirmado. En breve se actualizara el estado de tus pedidos.'
        : 'Tu pago fue procesado por Mercado Pago. Estamos confirmando el resultado.',
      variant: 'success',
    },
    fallido: {
      title: 'Pago fallido',
      message: 'No se pudo completar el pago. Podes volver a intentarlo desde el portal.',
      variant: 'error',
    },
    pendiente: {
      title: 'Pago pendiente',
      message: 'El pago quedo pendiente. Cuando se acredite, el estado de tus pedidos se actualizara.',
      variant: 'warning',
    },
  };

  const current = config[computedStatus] || config.fallido;

  return (
    <div className="page-shell">
      <section className={`panel result-panel result-panel--${current.variant}`}>
        <p className="eyebrow">Resultado del pago</p>
        <h1>{current.title}</h1>
        <p>{current.message}</p>

        {paymentId ? (
          <div className="result-detail">
            <span>ID de pago</span>
            <strong>{paymentId}</strong>
          </div>
        ) : null}

        {computedStatus === 'exitoso' && confirming ? (
          <p className="loading-text">Confirmando el pago en el sistema...</p>
        ) : null}

        {error ? <div className="alert error">{error}</div> : null}

        <div className="hero-actions">
          <Link to="/portal" className="btn-primary">
            Volver al portal
          </Link>
        </div>
      </section>
    </div>
  );
}
